// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LinkPrimary_wrapper__no0zm"};